// Route mappings for bilingual URLs
export const routeMap = {
  home: { en: '/', es: '/es/' },
  about: { en: '/about', es: '/es/acerca' },
  services: { en: '/services', es: '/es/servicios' },
  smartPricing: { en: '/smart-pricing', es: '/es/smart-pricing' },
  consulting: { en: '/consulting', es: '/es/consultoria' },
  research: { en: '/research', es: '/es/investigacion' },
  blog: { en: '/blog', es: '/es/blog' },
  blogPost: { en: '/blog', es: '/es/blog' },
  contact: { en: '/contact', es: '/es/contacto' },
  privacyPolicy: { en: '/privacy-policy', es: '/es/politica-privacidad' },
  termsOfService: { en: '/terms-of-service', es: '/es/terminos-servicio' },
  cookiePolicy: { en: '/cookie-policy', es: '/es/politica-cookies' },
  disclaimer: { en: '/disclaimer', es: '/es/descargo' },
  dataProcessing: { en: '/data-processing', es: '/es/procesamiento-datos' },
} as const;

export type RouteKey = keyof typeof routeMap;
export type Language = 'en' | 'es';

// Get localized route
export const getLocalizedRoute = (routeKey: RouteKey, language: Language): string => {
  return routeMap[routeKey][language];
};

// Get language from path
export const getLanguageFromPath = (pathname: string): Language => {
  return pathname.startsWith('/es') ? 'es' : 'en';
};

// Get route key from path
export const getRouteKeyFromPath = (pathname: string): RouteKey | null => {
  // Remove trailing slash and normalize
  const normalizedPath = pathname.replace(/\/$/, '') || '/';
  
  for (const [key, paths] of Object.entries(routeMap)) {
    if (paths.en === normalizedPath || paths.es === normalizedPath || 
        paths.en === normalizedPath + '/' || paths.es === normalizedPath + '/') {
      return key as RouteKey;
    }
  }
  
  // Check for blog posts
  if (pathname.match(/^\/(es\/)?blog\/.+/)) {
    return 'blog';
  }
  
  return null;
};

// Translate current path to another language
export const translatePath = (currentPath: string, targetLanguage: Language): string => {
  // Handle blog post URLs
  const blogPostMatch = currentPath.match(/^\/(es\/)?blog\/(.+)/);
  if (blogPostMatch) {
    const slug = blogPostMatch[2];
    return targetLanguage === 'es' ? `/es/blog/${slug}` : `/blog/${slug}`;
  }
  
  const routeKey = getRouteKeyFromPath(currentPath);
  if (routeKey) {
    return getLocalizedRoute(routeKey, targetLanguage);
  }
  
  // Default fallback
  return targetLanguage === 'es' ? '/es/' : '/';
};
